import { CarouselProps } from './Carousel.types'

export const defaultProps: Partial<CarouselProps> = {
  usePagination: true,
  isPaginationClickable: false,
  slidesPerView: 1.3,
  spaceBetweenSlides: 20
}
